var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-code',_vm._b({staticClass:"my-0"},'app-code',_vm.$attrs,false),[_c('prism',{ref:"code",attrs:{"code":_vm.code,"inline":_vm.inline,"language":_vm.language}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }